// /signin/expired: used/expired link, ask for a fresh one.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthShell } from './AuthShell.jsx';
import { EmailSignInForm } from './EmailSignIn.jsx';

export default function LinkExpired() {
  const navigate = useNavigate();
  return (
    <AuthShell
      aside={<><b>Links not arriving?</b> Check your spam or "Other" folder, or write to{' '}
        <a className="underline" href="mailto:hello@flowize-mcp.xyz">hello@flowize-mcp.xyz</a> and a human will help.</>}
    >
      <h1 className="text-2xl font-semibold text-gray-900">That link has already been used.</h1>
      <p className="text-sm text-gray-600 mt-2 mb-6">
        Sign-in links work once, for 15 minutes, to keep your account safe. No problem: we'll send you a fresh one.
      </p>
      <EmailSignInForm
        submitLabel="Email me a new link"
        onSent={(masked) => navigate('/signin/check', { state: { masked } })}
      />
    </AuthShell>
  );
}
